import { assign } from 'lodash';
import EventEmitter from '@wsb/commerce-event-emitter';
import AppDispatcher from '../dispatcher/AppDispatcher';
import YotpoConstants from '../constants/YotpoConstants';

class YotpoStore extends EventEmitter {
  constructor() {
    super(...arguments);

    this.state = {
      wasLoaded: false
    };
    this.register();
  }

  setState(newState) {
    assign(this.state, newState);
    this.emit('change');
  }

  getState() {
    return this.state;
  }

  register() {
    this.dispatchToken = AppDispatcher.register((payload) => {
      const { action } = payload;

      switch (action.type) {
        case YotpoConstants.YOTPO_WAS_LOADED:
          this.setState({
            wasLoaded: true
          });
          break;
        default:
          break;
      }
    });
  }
}

export default new YotpoStore();
